import axios from 'axios';
import type {
  IGetAnsweringServicePayerAndTypeParams,
  IGetAnsweringServicePayerAndTypeRequest,
  IGetAnsweringServicePayerAndTypeResponse,
} from '@/app-package';

const getAnsweringServicePayerAndType = async (
  params: IGetAnsweringServicePayerAndTypeParams,
): Promise<IGetAnsweringServicePayerAndTypeResponse> => {
  const config: IGetAnsweringServicePayerAndTypeRequest = {
    url: `/answering_service/payer_and_type/${params.orgId}`,
    method: 'get',
  };

  const { data } =
    await axios.request<IGetAnsweringServicePayerAndTypeResponse>(config);
  return data;
};

export default getAnsweringServicePayerAndType;
